// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker.range-datepicker .react-datepicker__header {
  padding: 4px 0 0 !important;
}

.react-datepicker.range-datepicker .react-datepicker__navigation--previous,
.react-datepicker.range-datepicker .react-datepicker__navigation--next {
  top: 16px;
  border-radius: 12px;
}

.react-datepicker.range-datepicker .react-datepicker__navigation--previous {
  left: 16px;
}

.react-datepicker.range-datepicker .react-datepicker__navigation--next {
  right: 16px;
}

.react-datepicker.range-datepicker .react-datepicker__navigation--previous:hover,
.react-datepicker.range-datepicker .react-datepicker__navigation--next:hover {
  background-color: none !important;
  border: 1px solid #2563EB;
}

.react-datepicker.range-datepicker .react-datepicker__navigation--previous:hover .react-datepicker.range-datepicker .react-datepicker__navigation-icon--previous::before,
.react-datepicker.range-datepicker .react-datepicker__navigation--next:hover .react-datepicker.range-datepicker .react-datepicker__navigation-icon--next::before {
  border-color: #2563EB;
}

.react-datepicker.range-datepicker .react-datepicker__day-names {
  gap: 4px;
  padding: 0 16px;
  margin: 2px 0;
}

.react-datepicker.range-datepicker .react-datepicker__day-name {
  width: 40px !important;
  height: 32px !important;
  margin: 0;
  color: #474853;
  line-height: 20px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-datepicker.range-datepicker .react-datepicker__header__dropdown {
  height: 0;
}

.react-datepicker.range-datepicker {
  width: 680px;
}

.react-datepicker.range-datepicker .react-datepicker__month-container {
  width: 340px;
}

.react-datepicker.range-datepicker .react-datepicker__current-month {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #11113A;
  height: 56px;
  margin-bottom: 2px;
}

.react-datepicker.range-datepicker .react-datepicker__month {
  padding: 0 16px 16px;
}

.react-datepicker.range-datepicker .react-datepicker__week {
  display: block;
}

.react-datepicker.range-datepicker .react-datepicker__day {
  width: 42px;
  height: auto;
  margin: 1px;
  border: 1px solid transparent;
  display: inline-block;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  color: #11113A !important;
  font-size: 14px;
  line-height: 38px;
  font-weight: 400;
  box-sizing: border-box;
}

.react-datepicker.range-datepicker .react-datepicker__day:hover {
  border-color: #2563EB;
  color: #11113A;
  background-color: transparent !important;
  border-radius: 14px !important;
}

.react-datepicker.range-datepicker .react-datepicker__day--selected,
.react-datepicker.range-datepicker .react-datepicker__day--in-selecting-range,
.react-datepicker.range-datepicker .react-datepicker__day--range-end,
.react-datepicker.range-datepicker .react-datepicker__day--range-start,
.react-datepicker.range-datepicker .react-datepicker__day--in-range {
  background-color: #2563EB !important;
  color: #ffffff !important;
  border: 1px solid #2563EB;
}

.react-datepicker.range-datepicker .react-datepicker__day--outside-month:hover,
.react-datepicker.range-datepicker .react-datepicker__day--selected:hover,
.react-datepicker.range-datepicker .react-datepicker__day--in-selecting-range:hover,
.react-datepicker.range-datepicker .react-datepicker__day--range-end:hover,
.react-datepicker.range-datepicker .react-datepicker__day--range-start:hover,
.react-datepicker.range-datepicker .react-datepicker__day--in-range:hover {
  background-color: #ffffff !important;
  color: #2563EB !important;
  border: 1px solid #2563EB;
}

.react-datepicker.range-datepicker .react-datepicker__day--outside-month {
  border: none;
}

.react-datepicker.range-datepicker .react-datepicker__month-container:first-of-type {
  border-right: 1px solid #E6EDF3;
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/DateRangeFilter/react-date-picker.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;;;;EAKE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".react-datepicker.range-datepicker .react-datepicker__header {\n  padding: 4px 0 0 !important;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__navigation--previous,\n.react-datepicker.range-datepicker .react-datepicker__navigation--next {\n  top: 16px;\n  border-radius: 12px;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__navigation--previous {\n  left: 16px;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__navigation--next {\n  right: 16px;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__navigation--previous:hover,\n.react-datepicker.range-datepicker .react-datepicker__navigation--next:hover {\n  background-color: none !important;\n  border: 1px solid #2563EB;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__navigation--previous:hover .react-datepicker.range-datepicker .react-datepicker__navigation-icon--previous::before,\n.react-datepicker.range-datepicker .react-datepicker__navigation--next:hover .react-datepicker.range-datepicker .react-datepicker__navigation-icon--next::before {\n  border-color: #2563EB;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__day-names {\n  gap: 4px;\n  padding: 0 16px;\n  margin: 2px 0;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__day-name {\n  width: 40px !important;\n  height: 32px !important;\n  margin: 0;\n  color: #474853;\n  line-height: 20px;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__header__dropdown {\n  height: 0;\n}\n\n.react-datepicker.range-datepicker {\n  width: 680px;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__month-container {\n  width: 340px;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__current-month {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  color: #11113A;\n  height: 56px;\n  margin-bottom: 2px;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__month {\n  padding: 0 16px 16px;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__week {\n  display: block;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__day {\n  width: 42px;\n  height: auto;\n  margin: 1px;\n  border: 1px solid transparent;\n  display: inline-block;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  color: #11113A !important;\n  font-size: 14px;\n  line-height: 38px;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__day:hover {\n  border-color: #2563EB;\n  color: #11113A;\n  background-color: transparent !important;\n  border-radius: 14px !important;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__day--selected,\n.react-datepicker.range-datepicker .react-datepicker__day--in-selecting-range,\n.react-datepicker.range-datepicker .react-datepicker__day--range-end,\n.react-datepicker.range-datepicker .react-datepicker__day--range-start,\n.react-datepicker.range-datepicker .react-datepicker__day--in-range {\n  background-color: #2563EB !important;\n  color: #ffffff !important;\n  border: 1px solid #2563EB;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__day--outside-month:hover,\n.react-datepicker.range-datepicker .react-datepicker__day--selected:hover,\n.react-datepicker.range-datepicker .react-datepicker__day--in-selecting-range:hover,\n.react-datepicker.range-datepicker .react-datepicker__day--range-end:hover,\n.react-datepicker.range-datepicker .react-datepicker__day--range-start:hover,\n.react-datepicker.range-datepicker .react-datepicker__day--in-range:hover {\n  background-color: #ffffff !important;\n  color: #2563EB !important;\n  border: 1px solid #2563EB;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__day--outside-month {\n  border: none;\n}\n\n.react-datepicker.range-datepicker .react-datepicker__month-container:first-of-type {\n  border-right: 1px solid #E6EDF3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
